module.exports = __webpack_public_path__ + "static/img/sf-item-02.9ba1819.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/sf-item-02.png
// module id = t54a
// module chunks = 2